import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing16,
  spacing20,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { ImagePickerMode, THUMBNAIL_WIDTH } from './image-picker.constants';
import ContentCard from 'approot/shared/content-card/content-card';

type AvatarEditorContainerProps = {
  mode?: ImagePickerMode;
};

export const ImagePickerAvatarEditor = styled.div<AvatarEditorContainerProps>`
  position: relative;
  ${({ mode }) =>
    mode !== ImagePickerMode.Hero &&
    `
    margin: 0 auto;
    width: ${rem(300)};
  `};
`;

export const ImageDeleteButtonWrapper = styled.div<AvatarEditorContainerProps>`
  position: absolute;
  z-index: 1;
  padding-top: ${rem(spacing20)};
  top: 0;
  ${({ mode }) =>
    mode === ImagePickerMode.Hero
      ? `
    right: ${rem(spacing40)};
    `
      : `
    right: ${rem(spacing20)};

    `};
`;

export const ImagePickerContentCard = styled(ContentCard)`
  margin: 0 auto ${rem(spacing16)};
  width: ${rem(THUMBNAIL_WIDTH)};
`;

export const ImagePickerCardWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ImagePickerButtonContainer = styled.div`
  text-align: center;
`;

export const ImagePickerContainer = styled.div`
  position: relative;
`;

export const ImagePickerDisabledOverlay = styled.div`
  background-color: rgba(255, 255, 255, 0.4);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  &:hover {
    cursor: not-allowed;
  }
`;
